import type {ReactNode} from 'react';

import type {AfriexAdminPermission} from '@afriex/core/domain/enums';
import {hasAdminPermission} from '@afriex/core/utils';

// A gate takes the core permission of the endpoint its control calls.
type PermissionsProviderProps = {
  permission: AfriexAdminPermission;
  children: ReactNode;
};

export function PermissionsProvider({
  permission,
  children,
}: PermissionsProviderProps) {
  // A pure synchronous lookup over a static table (plus a `localStorage` read
  // for the current role), so the answer is derivable during render. Holding
  // it in state behind an effect only meant gated children flashed absent for
  // one frame on every mount.
  const isAllowed = hasAdminPermission(
    localStorage.getItem('admin-role') ?? undefined,
    permission,
  );

  return <>{isAllowed ? children : null}</>;
}

export default PermissionsProvider;
